"use strict";
'use es6';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = require("react");

var _reactDom = _interopRequireDefault(require("react-dom"));

function ModalFramePortal(_ref) {
  var children = _ref.children;
  var modalRef = (0, _react.useRef)(document.createElement('div'));
  (0, _react.useLayoutEffect)(function () {
    var currentModalRef = modalRef.current;
    document.body.appendChild(currentModalRef);
    return function () {
      document.body.removeChild(currentModalRef);
    };
  }, []);
  return _reactDom.default.createPortal(children, modalRef.current);
}

var _default = ModalFramePortal;
exports.default = _default;
module.exports = exports.default;